import {forwardRef, useImperativeHandle} from "react";
import {useBoolState, ConfirmDialog} from "@dvrt/graphql-widgets";
import ResyncProgressDialog from "./ResyncProgressDialog";
import {defineMessage} from "react-intl";

export type ResyncDialogProps = {
    devicesToResync: number[];
    name?: string;
};
export type ResyncDialogHandler = {open: () => void};

const ResyncDialog = forwardRef<ResyncDialogHandler, ResyncDialogProps>(({devicesToResync, name}, ref) => {
    const [isOpenResync, openResync, closeResync] = useBoolState();
    const [isOpenResyncPrompt, openResyncPrompt, closeResyncPrompt] = useBoolState();

    useImperativeHandle(
        ref,
        () => ({
            open: openResyncPrompt,
        }),
        [openResyncPrompt],
    );

    return (
        <>
            <ConfirmDialog
                isOpen={isOpenResyncPrompt}
                close={closeResyncPrompt}
                onConfirm={() => {
                    closeResyncPrompt();
                    openResync();
                }}
                message={
                    name
                        ? defineMessage({
                              id: "prompt_resync",
                              defaultMessage:
                                  "Resyncronization is needed for the device {name}. Do you want to perform it now?",
                          })
                        : defineMessage({
                              id: "prompt_resync_multi",
                              defaultMessage: "Some devices need resyncronization. Do you want to perform it now?",
                          })
                }
                messageVars={{name}}
                buttonIdPrefix="resync-device"
            />
            <ResyncProgressDialog
                deviceIdList={devicesToResync}
                isOpen={isOpenResync}
                close={closeResync}
                name={name}
            />
        </>
    );
});

export default ResyncDialog;
